import { Navigate, Outlet } from 'react-router-dom';
import { useAppSelector } from '@/app/store/hooks';
import { ROUTES } from '@/shared/config/routes';

/** §3.8 «администратор системы» (`users.is_admin`) — не роль внутри магазина, глобальный флаг на
 *  пользователе, поэтому проверяется прямо из `auth`-состояния, не через `<StoreScope/>`. */
export function RequireAdmin() {
  const isAdmin = useAppSelector((state) => state.auth.user?.isAdmin ?? false);
  if (!isAdmin) return <Navigate to={ROUTES.stores} replace />;
  return <Outlet />;
}
